import {Accordion, AccordionTab} from "primereact/accordion";
import React from "react";
import {useTranslation} from "react-i18next";
import {Card} from "primereact/card";

const Alarms = ()=>{
    const { t } = useTranslation();

    return(
        <Card
            title={t('warnings')}
            id="projectsInfo"
            style={{ margin: "0.5em auto", overflowX: "auto", }}
        >
            <div className="col-12 lg:col-12">
                <p>{t('in_progress')}.....................</p>
                {/*<div className="alert-box mt-4">*/}
                {/*    <h3>{t('warnings')}</h3>*/}
                {/*    <p>{t('in_progress')}.....................</p>*/}
                {/*</div>*/}
                {/*<Accordion activeIndex={0} className="">*/}
                {/*    <AccordionTab header={}>*/}
                {/*<div className="flex justify-content-between align-items-center single-alert">*/}
                {/*  <div className="flex align-items-center">*/}
                {/*    <AiFillWarning color="orange" fontSize={"18px"} />*/}
                {/*    <p className="ml-2">23.0.5.2022 17:58:32</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <p>Project A</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <p>Weststrasse5</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <i className="pi pi-eye p-0 m-0"></i>*/}
                {/*  </div>*/}
                {/*</div>*/}
                {/*<div className="flex justify-content-between align-items-center single-alert">*/}
                {/*  <div className="flex align-items-center">*/}
                {/*    <MdNotificationsActive color="red" fontSize={"18px"} />*/}
                {/*    <p className="ml-2">23.0.5.2022 17:58:32</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <p>Project A</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <p>Weststrasse5</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <i className="pi pi-eye p-0 m-0"></i>*/}
                {/*  </div>*/}
                {/*</div>*/}
                {/*<div className="flex justify-content-between align-items-center single-alert">*/}
                {/*  <div className="flex align-items-center">*/}
                {/*    <MdNotificationsActive color="red" fontSize={"18px"} />*/}
                {/*    <p className="ml-2">23.0.5.2022 17:58:32</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <p>Project A</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <p>Weststrasse5</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <i className="pi pi-eye p-0 m-0"></i>*/}
                {/*  </div>*/}
                {/*</div>*/}
                {/*<div className="flex justify-content-between align-items-center single-alert">*/}
                {/*  <div className="flex align-items-center">*/}
                {/*    <AiFillWarning color="orange" fontSize={"18px"} />*/}
                {/*    <p className="ml-2">23.0.5.2022 17:58:32</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <p>Project A</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <p>Weststrasse5</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <i className="pi pi-eye p-0 m-0"></i>*/}
                {/*  </div>*/}
                {/*</div>*/}
                {/*<div className="flex justify-content-between align-items-center single-alert">*/}
                {/*  <div className="flex align-items-center">*/}
                {/*    <AiFillWarning color="orange" fontSize={"18px"} />*/}
                {/*    <p className="ml-2">23.0.5.2022 17:58:32</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <p>Project A</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <p>Weststrasse5</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <i className="pi pi-eye p-0 m-0"></i>*/}
                {/*  </div>*/}
                {/*</div>*/}
                {/*<div className="flex justify-content-between align-items-center single-alert">*/}
                {/*  <div className="flex align-items-center">*/}
                {/*    <AiFillWarning color="orange" fontSize={"18px"} />*/}
                {/*    <p className="ml-2">23.0.5.2022 17:58:32</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <p>Project A</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <p>Weststrasse5</p>*/}
                {/*  </div>*/}
                {/*  <div>*/}
                {/*    <i className="pi pi-eye p-0 m-0"></i>*/}
                {/*  </div>*/}
                {/*</div>*/}
                {/*    </AccordionTab>*/}
                {/*</Accordion>*/}
            </div>

        </Card>

    )
}

export default Alarms;